import { ReactNode, useContext, useState } from 'react';
import UserImage2Webp from '../../../assets/img/wanna/wanna1.webp';
import Avatar from '../../../components/Avatar';
import Dropdown, {
	DropdownItem,
	DropdownMenu,
	DropdownToggle,
} from '../../../components/bootstrap/Dropdown';
import { NavLink, useNavigate } from 'react-router-dom';
import Icon from '../../../components/icon/Icon';
import PrefixModal from './PrefixModal';
import { useTranslation } from 'react-i18next';
import AuthContext from '../../../contexts/authContext';
import { demoPagesMenu } from '../../../menu';

const CommonHeaderChat = () => {
	const { t } = useTranslation(['translation', 'menu']);

	const { logout } = useContext(AuthContext);

	const navigate = useNavigate();

	const [state, setState] = useState<boolean>(false);
	const [msgCount, setMsgCount] = useState<number>(0);

	const [isModalOpen, setIsModalOpen] = useState(false);

	let user: any = {};
	let user_role: any = {};

	try {
		const raw = localStorage.getItem('neels_authUsername');
		const role = localStorage.getItem('neels_rights');

		if (raw && raw !== 'undefined' && raw !== 'null') {
			user = JSON.parse(raw);
		}
		if (role && role !== 'undefined' && role !== 'null') {
			user_role = JSON.parse(role);
		} else {
			user_role = {}; // Or provide a default value if role is null
		}
	} catch (err) {
		console.warn('Invalid user data in localStorage', err);
		user = {};
	}

	const handleLogout = async () => {
		await logout();
		navigate(`../${demoPagesMenu.login.path}`, { replace: true });
	};

	return (
		<>
			{/* <div
				className='col d-flex align-items-center cursor-pointer'
				onClick={() => setState(!state)}
				role='presentation'>
				<div className='me-3'>
					<div className='text-end'>
						<div className='fw-bold fs-6 mb-0'>
							{`${USERS.CHLOE.name} ${USERS.CHLOE.surname}`}
							{`${user?.username}`}
						</div>
						<div className='text-muted'>
							<small>{USERS.CHLOE.position}</small>
							<small>{user?.email}</small>
						</div>
					</div>
				</div>
				<div className='position-relative'>
					<Avatar
						// srcSet={USERS.CHLOE.srcSet}
						// src={USERS.CHLOE.src}
						src={user?.src ? user?.src : UserImage2Webp}
						size={48}
						// color={USERS.CHLOE.color}
					/>
					{!!msgCount && (
						<span className='position-absolute top-15 start-85 translate-middle badge rounded-pill bg-danger'>
							{msgCount} <span className='visually-hidden'>unread messages</span>
						</span>
					)}
					<span className='position-absolute top-85 start-85 translate-middle badge border border-2 border-light rounded-circle bg-success p-2'>
						<span className='visually-hidden'>Online user</span>
					</span>
				</div>
			</div> */}
			<div
				className='custom-dropdown'
				style={{
					flexShrink: 'unset',
					width: 'unset',
					maxWidth: 'unset',
				}}>
				<Dropdown>
					<DropdownToggle>
						<div
							className='col d-flex align-items-center cursor-pointer'
							onClick={() => setState(!state)}
							role='presentation'>
							<div className='me-3'>
								<div className='text-end'>
									<div className='fw-bold fs-6 mb-0'>
										{/* {`${USERS.CHLOE.name} ${USERS.CHLOE.surname}`} */}
										{`${user?.username}`}
									</div>
									<div className='text-muted'>
										{/* <small>{USERS.CHLOE.position}</small> */}
										<small>{user?.email}</small>
									</div>
								</div>
							</div>
							<div className='position-relative'>
								<Avatar
									// srcSet={USERS.CHLOE.srcSet}
									// src={USERS.CHLOE.src}
									src={user?.src ? user?.src : UserImage2Webp}
									size={48}
								// color={USERS.CHLOE.color}
								/>
								{!!msgCount && (
									<span className='position-absolute top-15 start-85 translate-middle badge rounded-pill bg-danger'>
										{msgCount}{' '}
										<span className='visually-hidden'>unread messages</span>
									</span>
								)}
								<span className='position-absolute top-85 start-85 translate-middle badge border border-2 border-light rounded-circle bg-success p-2'>
									<span className='visually-hidden'>Online user</span>
								</span>
							</div>
						</div>
					</DropdownToggle>
					<DropdownMenu>
						<DropdownItem>
							<NavLink to='/company-profile/update'>
								<Icon icon='Person' /> Company Profile
							</NavLink>
						</DropdownItem>
						<DropdownItem isDivider />

						<DropdownItem onClick={() => setIsModalOpen(true)}>
							<div className='d-flex align-items-center'>
								<Icon icon='Settings' className='me-2' />
								Settings
							</div>
						</DropdownItem>
						{
							user_role?.role === 'Admin' && (
								<>
									<DropdownItem isDivider />
									<DropdownItem>
										<NavLink to='/reset-password'>
											<Icon icon='Refresh' /> Reset Login
										</NavLink>
									</DropdownItem>
								</>
							)
						}
						<DropdownItem isDivider />
						<DropdownItem>
							<NavLink to='/change-password'>
								<Icon icon='Login' /> Change Login
							</NavLink>
						</DropdownItem>
						<DropdownItem isDivider />
						<DropdownItem>
							<div
								role='presentation'
								className='cursor-pointer d-flex align-items-center dropdown-item'
								onClick={handleLogout}>
								<div className='d-flex align-items-center'>
									<Icon icon='Logout' className='navigation-icon' />
									<span className='navigation-text'>
										{t('menu:Logout') as ReactNode}
									</span>
								</div>
							</div>
						</DropdownItem>
					</DropdownMenu>
				</Dropdown>
			</div>
			<PrefixModal isOpen={isModalOpen} toggle={() => setIsModalOpen(false)} />
			{/* <OffCanvas
				id='chat'
				isOpen={state}
				setOpen={setState}
				placement='end'
				isModalStyle
				isBackdrop={false}
				isBodyScroll>
				<OffCanvasHeader setOpen={setState} className='fs-5'>
					<ChatHeader to={USERS.CHLOE.name} />
				</OffCanvasHeader>
				<OffCanvasBody>
					<Chat>
						{CHATS.CHLOE_VS_JOHN.map((msg) => (
							<ChatGroup
								key={msg.id}
								messages={msg.messages}
								user={msg.user}
								isReply={msg.isReply}
							/>
						))}
					</Chat>
				</OffCanvasBody>
				<div className='chat-send-message p-3'>
					<InputGroup>
						<Textarea />
						<Button color='info' icon='Send'>
							SEND
						</Button>
					</InputGroup>
				</div>
			</OffCanvas> */}
		</>
	);
};

export default CommonHeaderChat;
